import { render, staticRenderFns } from "./addTeacher.vue?vue&type=template&id=94872492&scoped=true&"
import script from "./addTeacher.vue?vue&type=script&lang=js&"
export * from "./addTeacher.vue?vue&type=script&lang=js&"
import style0 from "./addTeacher.vue?vue&type=style&index=0&id=94872492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94872492",
  null
  
)

export default component.exports